import { dateTimePickerComponent } from '../modules/shared/dateTimePicker.component';
import { fixedHeight } from '../directive/fixedHeight';
import { browserPageComponent } from './browser.page.component';
import { compareTo } from '../directive/compareTo';
import { passwordValidation } from '../directive/passwordValidation';
import { bytes } from '../filters/bytes.filter';
import { LocationService } from '../services/location.service';
import { AppService } from './app.service';
import {loadNg1Module, ngmodule} from '../bootstrap/ngmodule';
import {app} from './app.component';
import { appState, browserState } from './app.states';
import { config, html5ConfigBlock, otherwiseConfigBlock, themeConfigBlock } from './app.config';
import {run} from'./app.run';
import { SettingsService, EnumService } from '../services';
import { operandoNavbar } from "./navbar.component";
import { chatPanelComponent } from "./chatPanel.component";
import { newsPanelComponent } from "./newsPanel.component";
import { file } from '../directive/file';
import { twinfieldComponent } from '../components/twinfield.component';

/**
 * Setting main app module
 */
const mainAppModule: aboTheme.INgModule = {
  components: {app, operandoNavbar, chatPanelComponent, browserPageComponent, dateTimePickerComponent, newsPanelComponent, twinfieldComponent },
  states: [appState, browserState],
  configBlocks: [config, otherwiseConfigBlock, html5ConfigBlock, themeConfigBlock],
  runBlocks: [run],
  services: {AppService, LocationService, SettingsService, EnumService},
  filters : {bytes},
  directives: {passwordValidation, compareTo, fixedHeight, file}
};

loadNg1Module(ngmodule, mainAppModule);





// WEBPACK FOOTER //
// ./src/app/main/index.ts